import React from 'react';
import { useEffect } from 'react';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

export function useBlocker(blocker: (tx: any) => void, when: boolean) {
  const { navigator } = React.useContext(NavigationContext);

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;
    const replace = navigator.replace;

    navigator.push = (...args: [any, ...any[]]) => {
      blocker({
        action: 'PUSH',
        location: args[0],
        retry: () => push(...args),
      });
    };

    navigator.replace = (...args: [any, ...any[]]) => {
      blocker({
        action: 'REPLACE',
        location: args[0],
        retry: () => replace(...args),
      });
    };

    return () => {
      navigator.push = push;
      navigator.replace = replace;
    };
  }, [blocker, navigator, when]);
}
